import { forwardRef } from "react";
import { GrPowerReset } from "react-icons/gr";
import styled from "styled-components";

import { ButtonProps } from "@/utils/types";

const Button = styled.button`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: none;
  width: 36px;
  height: 36px;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.5s ease-out, width 0.5s ease-out,
      height 0.5s ease-out;
  }

  @media (hover: hover) {
    &:hover {
      &::after {
        width: 100%;
        height: 100%;
        transform: translate(-50%, -50%) scale(1);
      }
    }
  }

  @media (hover: none) {
    &:active {
      &::after {
        width: 100%;
        height: 100%;
        transform: translate(-50%, -50%) scale(1);
      }
    }
  }
`;

const StyledMicIcon = styled(GrPowerReset)`
  color: rgba(162, 162, 162, 1);
`;

export const ButtonReset = forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    onButtonDown: () => void;
  }
>(
  (
    { className, disabled, onClick, onMouseDown, onMouseUp, onButtonDown },
    ref,
  ) => {
    const handleButtonDown = () => {
      onButtonDown();
    };

    return (
      <Button
        className={className}
        type="button"
        disabled={disabled}
        ref={ref}
        onClick={onClick}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onPointerDown={handleButtonDown}
        onTouchStart={handleButtonDown}
      >
        <StyledMicIcon size={22} />
      </Button>
    );
  },
);
